function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 10px;\n  margin: 5px 3px;\n  cursor: pointer;\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import styled from "styled-components";
var CategoryContainer = styled.div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.secondary;
}, function(param) {
    var theme = param.theme;
    return theme.palette.secondary;
}, function(param) {
    var theme = param.theme, selected = param.selected;
    return selected && "\n    background-color: ".concat(theme.palette.secondary, "\n    color: #fff;\n  ");
});
var Category = function(param) {
    var category = param.category, selectCategory = param.selectCategory, selectedCategories = param.selectedCategories;
    var selected = selectedCategories.find(function(cat) {
        return cat === category.id;
    });
    return /*#__PURE__*/ React.createElement(CategoryContainer, {
        className: "".concat(selected ? "category-filter selected" : "category-filter"),
        selected: selected,
        onClick: function() {
            return selectCategory(category.id);
        }
    }, category.name);
};
export default Category;
